import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { navigateToBlogSection } from '../../actions/navigate-to-blog-section';

import { closePostEditorOnBrowserBack, cleanPostEditorState } from '../../actions/post-editor';
import { getPostEditorDraftKey } from '../../selectors/post-editor-selectors';
import { isOneApp } from '@wix/communities-blog-client-common/dist/src/selectors/search-params-selectors';
import { isPostEditorDeprecated } from '@wix/communities-blog-client-common/dist/src/selectors/experiments-selectors';
import { initPostEditor } from '../../services/post-editor';
import styles from './post-editor-modal-loader.scss';
import { resolvePostSlug } from '../../services/slug';

class PostEditorModalLoader extends Component {
  componentDidMount() {
    if (this.props.isPostEditorDeprecated) {
      this.props.navigateToBlogSection('/');
    } else {
      this.props.initPostEditor(resolvePostSlug(this.props.params));
    }
  }

  componentWillUnmount() {
    // On cancel and publish modal is closed by post publish middleware with.
    // This one is needed for browser back button
    this.props.closePostEditorOnBrowserBack();
    this.props.cleanPostEditorState(this.props.draftKey);
  }

  render() {
    const className = classNames(styles.container, {
      'blog-card-background-color': this.props.isOneApp,
    });
    return <div className={className} />;
  }
}

PostEditorModalLoader.propTypes = {
  route: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  initPostEditor: PropTypes.func.isRequired,
  closePostEditorOnBrowserBack: PropTypes.func.isRequired,
  cleanPostEditorState: PropTypes.func.isRequired,
  navigateToBlogSection: PropTypes.func.isRequired,
  isPostEditorDeprecated: PropTypes.bool.isRequired,
  draftKey: PropTypes.string,
  isOneApp: PropTypes.bool,
};

const mapStateToProps = state => ({
  draftKey: getPostEditorDraftKey(state),
  isOneApp: isOneApp(state),
  isPostEditorDeprecated: isPostEditorDeprecated(state),
});

const mapDispatchToProps = {
  initPostEditor,
  closePostEditorOnBrowserBack,
  cleanPostEditorState,
  navigateToBlogSection,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PostEditorModalLoader);
